"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ApiV3DataTransformationBuilder () {
        return ApiV3DataTransformationBuilder;
    },
    get builderGenerator () {
        return builderGenerator;
    },
    get colOptionBuilder () {
        return colOptionBuilder;
    },
    get columnBuilder () {
        return columnBuilder;
    },
    get columnOptionsV3ToV2Builder () {
        return columnOptionsV3ToV2Builder;
    },
    get columnV3ToV2Builder () {
        return columnV3ToV2Builder;
    },
    get filterBuilder () {
        return filterBuilder;
    },
    get filterRevBuilder () {
        return filterRevBuilder;
    },
    get sortBuilder () {
        return sortBuilder;
    },
    get viewColumnBuilder () {
        return viewColumnBuilder;
    }
});
const _nocodbsdk = require("nocodb-sdk");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}
const convertToSnakeCase = (str)=>{
    return str.replace(/[A-Z]/g, (letter)=>`_${letter.toLowerCase()}`);
};
const convertToCamelCase = (str)=>{
    return str.replace(/_([a-z])/g, (_, letter)=>`${letter.toUpperCase()}`);
};
const columnsWithOptions = [
    _nocodbsdk.UITypes.Lookup,
    _nocodbsdk.UITypes.Links,
    _nocodbsdk.UITypes.LinkToAnotherRecord,
    _nocodbsdk.UITypes.Rollup,
    _nocodbsdk.UITypes.Lookup,
    _nocodbsdk.UITypes.Barcode,
    _nocodbsdk.UITypes.Formula,
    _nocodbsdk.UITypes.QrCode,
    _nocodbsdk.UITypes.Button,
    _nocodbsdk.UITypes.LongText
];
let ApiV3DataTransformationBuilder = class ApiV3DataTransformationBuilder {
    remapColumns(mappings) {
        this.transformations.push((data)=>{
            return Object.entries(data).reduce((result, [key, value])=>{
                const newKey = mappings[key] || key;
                result[newKey] = value;
                return result;
            }, {});
        });
        return this;
    }
    filterColumns(args) {
        this.transformations.push((data)=>{
            return Object.keys(data).filter((key)=>{
                if ('allowed' in args) return args.allowed.includes(key);
                if ('excluded' in args) return !args.excluded.includes(key);
            }).reduce((result, key)=>{
                result[key] = data[key];
                return result;
            }, {});
        });
        return this;
    }
    metaTransform(_0 = void 0) {
        let _ref = [
            _0
        ], [_ref1 = {}] = _ref, { snakeCase = true, camelCase = false, mappings = {}, metaProps = [
            'meta'
        ], skipTransformFor, skipfn } = _ref1, rest = _object_without_properties_loose(_ref1, [
            "snakeCase",
            "camelCase",
            "mappings",
            "metaProps",
            "skipTransformFor",
            "skipfn"
        ]);
        this.transformations.push((data)=>{
            const result = _extends({}, data);
            // iterate and update properties of metaProps only
            for (const prop of metaProps){
                if (result[prop]) {
                    if (typeof result[prop] === 'string') {
                        try {
                            result[prop] = JSON.parse(result[prop]);
                        } catch (unused) {}
                    } else {
                        result[prop] = _extends({}, result[prop]);
                    }
                    result[prop] = Object.entries(result[prop]).filter(([key])=>{
                        if ('excluded' in rest) {
                            return !rest.excluded.includes(key);
                        }
                        if ('allowed' in rest) {
                            return rest.allowed.includes(key);
                        }
                        return true;
                    }).reduce((result, [key, value])=>{
                        let newKey = mappings[key] || key;
                        if (skipTransformFor && skipTransformFor.includes(newKey) || skipfn && skipfn(data)) {
                            result[newKey] = value;
                            return result;
                        }
                        if (camelCase) {
                            newKey = convertToCamelCase(newKey);
                        } else if (snakeCase) {
                            newKey = convertToSnakeCase(newKey);
                        }
                        result[newKey] = value;
                        return result;
                    }, {});
                }
            }
            return result;
        });
        return this;
    }
    customTransform(transformFn) {
        this.transformations.push(transformFn);
        return this;
    }
    build(data) {
        if (Array.isArray(data)) {
            return data.map((item)=>this.transformations.reduce((result, transform)=>transform(result), item));
        }
        return this.transformations.reduce((result, transform)=>transform(result), data);
    }
    excludeNulls() {
        this.transformations.push((data)=>{
            return Object.entries(data).reduce((result, [key, value])=>{
                if (value !== null) {
                    result[key] = value;
                }
                return result;
            }, {});
        });
        return this;
    }
    excludeEmptyObject() {
        this.transformations.push((data)=>{
            return Object.entries(data).reduce((result, [key, value])=>{
                if (typeof value !== 'object' || Object.keys(value != null ? value : {}).length > 0) {
                    result[key] = value;
                }
                return result;
            }, {});
        });
        return this;
    }
    transformToBoolean(booleanProps) {
        this.transformations.push((data)=>{
            return Object.entries(data).reduce((result, [key, value])=>{
                if (booleanProps.includes(key)) {
                    result[key] = !!value;
                } else {
                    result[key] = value;
                }
                return result;
            }, {});
        });
        return this;
    }
    nestedExtract(nestedExtract) {
        this.transformations.push((data)=>{
            const result = _extends({}, data);
            Object.entries(nestedExtract).forEach(([key, path])=>{
                const value = path.reduce((acc, key)=>acc == null ? void 0 : acc[key], result);
                result[key] = value;
            });
            return result;
        });
    }
    orderProps(order) {
        // order props by order column and missing one keep at the end
        this.transformations.push((data)=>{
            // Initialize the ordered object with properties based on the order array
            const ordered = order.reduce((acc, key)=>{
                if (key in data) {
                    acc[key] = data[key];
                }
                return acc;
            }, {});
            // Add remaining properties from data that are not in the order array
            Object.keys(data).forEach((key)=>{
                if (!order.includes(key)) {
                    ordered[key] = data[key];
                }
            });
            return ordered;
        });
        return this;
    }
    constructor(){
        this.transformations = [];
    }
};
const builderGenerator = (_0)=>{
    let { mappings, transformFn, meta, excludeNullProps = true, excludeEmptyObjectProps = false, booleanProps, nestedExtract } = _0, rest = _object_without_properties_loose(_0, [
        "mappings",
        "transformFn",
        "meta",
        "excludeNullProps",
        "excludeEmptyObjectProps",
        "booleanProps",
        "nestedExtract"
    ]);
    return ()=>{
        const builder = new ApiV3DataTransformationBuilder();
        if (nestedExtract) {
            builder.nestedExtract(nestedExtract);
        }
        if (excludeNullProps) {
            builder.excludeNulls();
        }
        if (excludeEmptyObjectProps) {
            builder.excludeEmptyObject();
        }
        if (booleanProps) {
            builder.transformToBoolean(booleanProps);
        }
        if ('allowed' in rest || 'excluded' in rest) {
            builder.filterColumns(rest);
        }
        if ('orderProps' in rest) {
            builder.orderProps(rest.orderProps);
        }
        if (meta) {
            builder.metaTransform(meta);
        }
        if (mappings) {
            builder.remapColumns(mappings);
        }
        if (transformFn) {
            builder.customTransform(transformFn);
        }
        return builder;
    };
};
const colOptionBuilder = builderGenerator({
    allowed: [
        'formula_raw',
        'fk_qr_value_column_id',
        'fk_barcode_value_column_id',
        'fk_related_model_id',
        'type',
        'fk_relation_column_id',
        'fk_rollup_column_id',
        'fk_lookup_column_id',
        'rollup_function',
        'fk_webhook_id'
    ],
    mappings: {
        formula_raw: 'formula',
        fk_qr_value_column_id: 'qrcode_value_field_id',
        fk_barcode_value_column_id: 'barcode_value_field_id',
        fk_related_model_id: 'related_table_id',
        fk_relation_column_id: 'related_field_id',
        fk_rollup_column_id: 'related_table_rollup_field_id',
        fk_lookup_column_id: 'related_table_lookup_field_id',
        related_table_rollup_field_id: 'fk_rollup_column_id',
        fk_webhook_id: 'button_hook_id',
        fk_script_id: 'script_id'
    }
});
const columnBuilder = builderGenerator({
    allowed: [
        'id',
        'title',
        'uidt',
        'cdf',
        'description',
        'meta',
        'colOptions',
        'fk_model_id',
        'system',
        'unique'
    ],
    mappings: {
        uidt: 'type',
        cdf: 'default_value',
        meta: 'options',
        fk_model_id: 'table_id'
    },
    excludeNullProps: true,
    booleanProps: [
        'unique'
    ],
    meta: {
        snakeCase: true,
        metaProps: [
            'meta'
        ],
        mappings: {
            is12hrFormat: '12hr_format',
            isLocaleString: 'locale_string',
            richMode: 'rich_text',
            [_nocodbsdk.LongTextAiMetaProp]: 'generate_text_using_ai',
            isDisplayTimezone: 'display_timezone',
            is_multi: 'allow_multiple_users',
            is_progress: 'show_as_progress',
            max: 'max_value'
        },
        excluded: [
            'defaultViewColOrder',
            'defaultViewColVisibility',
            'singular',
            'plural'
        ],
        skipTransformFor: [
            'currency_locale',
            'currency_code',
            'icon',
            'iconIdx',
            'duration'
        ]
    },
    transformFn: (data)=>{
        var _Object_keys;
        let options = data.options || {};
        if (data.colOptions) {
            switch(data.type){
                case _nocodbsdk.UITypes.SingleSelect:
                case _nocodbsdk.UITypes.MultiSelect:
                    {
                        const choices = data.colOptions.options.map((opt)=>{
                            const res = {
                                title: opt.title,
                                color: opt.color
                            };
                            if (opt.id) res.id = opt.id;
                            return res;
                        });
                        options.choices = choices;
                    }
                    break;
                default:
                    {
                        const additionalOptions = colOptionBuilder().build(data.colOptions) || {};
                        Object.assign(options, additionalOptions);
                    }
                    break;
            }
        }
        if (data.type === _nocodbsdk.UITypes.Checkbox) {
            const { icon, iconIdx } = options, rest = _object_without_properties_loose(options, [
                "icon",
                "iconIdx"
            ]);
            // extract option meta and include only label and color
            options = rest;
            if (iconIdx) {
                var _checkboxIconList_iconIdx;
                options.icon = (_checkboxIconList_iconIdx = _nocodbsdk.checkboxIconList[iconIdx]) == null ? void 0 : _checkboxIconList_iconIdx.label;
            } else if (icon) {
                var _checkboxIconList_find;
                options.icon = (_checkboxIconList_find = _nocodbsdk.checkboxIconList.find((ic)=>ic.checked === (icon == null ? void 0 : icon['checked']))) == null ? void 0 : _checkboxIconList_find.label;
            }
        } else if (data.type === _nocodbsdk.UITypes.Rating) {
            const { icon, iconIdx } = options, rest = _object_without_properties_loose(options, [
                "icon",
                "iconIdx"
            ]);
            // extract option meta and include only label and color
            options = rest;
            if (iconIdx !== undefined && iconIdx !== null) {
                var _ratingIconList_iconIdx;
                options.icon = (_ratingIconList_iconIdx = _nocodbsdk.ratingIconList[iconIdx]) == null ? void 0 : _ratingIconList_iconIdx.label;
            } else if (icon) {
                var _ratingIconList_find;
                options.icon = (_ratingIconList_find = _nocodbsdk.ratingIconList.find((ic)=>ic.full === (icon == null ? void 0 : icon['full']))) == null ? void 0 : _ratingIconList_find.label;
            }
        } else if (data.type === _nocodbsdk.UITypes.Duration) {
            const { duration, duration_format } = options, rest = _object_without_properties_loose(options, [
                "duration",
                "duration_format"
            ]);
            const durationFormat = duration != null ? duration : duration_format;
            // extract option meta and include only label and color
            options = rest;
            if (durationFormat !== undefined && durationFormat !== null) {
                var _durationOptions_durationFormat;
                options.duration_format = (_durationOptions_durationFormat = _nocodbsdk.durationOptions[durationFormat]) == null ? void 0 : _durationOptions_durationFormat.title;
            }
        } else if (data.type === _nocodbsdk.UITypes.Button) {
            const { type } = options, rest = _object_without_properties_loose(options, [
                "type"
            ]);
            // Transform button properties based on type
            if (type === 'formula') {
                options = {
                    type,
                    formula: rest.formula,
                    label: rest.label,
                    color: rest.color,
                    theme: rest.theme,
                    icon: rest.icon
                };
            } else if (type === 'webhook') {
                options = {
                    type,
                    webhook_id: rest.button_hook_id,
                    label: rest.label,
                    color: rest.color,
                    theme: rest.theme,
                    icon: rest.icon
                };
            } else if (type === 'script') {
                options = {
                    type,
                    script_id: rest.script_id,
                    label: rest.label,
                    color: rest.color,
                    theme: rest.theme,
                    icon: rest.icon
                };
            } else if (type === 'ai') {
                options = {
                    type,
                    prompt: rest.prompt,
                    integration_id: rest.integration_id,
                    output_column_ids: rest.output_column_ids,
                    label: rest.label,
                    color: rest.color,
                    theme: rest.theme,
                    icon: rest.icon
                };
            } else {
                // Fallback to original transformation
                options = _extends({}, rest, {
                    button_type: type
                });
            }
        } else if ((0, _nocodbsdk.isLinksOrLTAR)(data.type)) {
            const { type } = options, rest = _object_without_properties_loose(options, [
                "type"
            ]);
            options = _extends({}, rest, {
                relation_type: type
            });
        }
        // exclude rollup function if Links
        if (data.type === _nocodbsdk.UITypes.Links && options && options.rollup_function) {
            options.rollup_function = undefined;
        }
        return _extends({}, data, {
            colOptions: undefined,
            options: options && ((_Object_keys = Object.keys(options)) == null ? void 0 : _Object_keys.length) ? options : undefined,
            // Explicitly preserve unique property
            unique: data.unique
        });
    }
});
const columnOptionsV3ToV2Builder = builderGenerator({
    allowed: [
        'formula',
        'qrcode_value_field_id',
        'barcode_value_field_id',
        'relation_type',
        'related_table_id',
        'related_field_id',
        'related_table_rollup_field_id',
        'related_table_lookup_field_id',
        'rollup_function',
        'button_hook_id',
        'script_id',
        'webhook_id',
        'type',
        'prompt',
        'integration_id',
        'output_column_ids',
        'label',
        'color',
        'theme',
        'icon'
    ],
    mappings: {
        formula: 'formula_raw',
        qrcode_value_field_id: 'fk_qr_value_column_id',
        barcode_value_field_id: 'fk_barcode_value_column_id',
        relation_type: 'type',
        button_hook_id: 'fk_webhook_id',
        script_id: 'fk_script_id',
        webhook_id: 'fk_webhook_id',
        // parent id we need to extract from the url
        related_table_id: 'childId',
        related_field_id: 'fk_relation_column_id',
        related_table_rollup_field_id: 'fk_rollup_column_id',
        related_table_lookup_field_id: 'fk_lookup_column_id'
    },
    transformFn: (data)=>{
        // Handle button specific transformations
        if (data.type) {
            // For button columns, convert type-specific structure to the V2 format
            if (data.type === 'formula' || data.type === 'webhook' || data.type === 'script' || data.type === 'ai') {
                return _extends({}, data, {
                    type: data.type
                });
            }
        }
        return data;
    }
});
const columnV3ToV2Builder = builderGenerator({
    allowed: [
        'id',
        'title',
        'type',
        'default_value',
        'options',
        'description',
        'unique'
    ],
    mappings: {
        type: 'uidt',
        default_value: 'cdf',
        options: 'meta'
    },
    meta: {
        snakeCase: false,
        camelCase: true,
        metaProps: [
            'options',
            'meta'
        ],
        mappings: {
            '12hr_format': 'is12hrFormat',
            locale_string: 'isLocaleString',
            rich_text: 'richMode',
            display_timezone: 'isDisplayTimezone',
            // LingText
            generate_text_using_ai: _nocodbsdk.LongTextAiMetaProp,
            allow_multiple_users: 'is_multi',
            show_as_progress: 'is_progress',
            max_value: 'max'
        },
        skipfn: (data)=>columnsWithOptions.includes(data.uidt || data.type),
        excluded: [
            'defaultViewColOrder',
            'singular',
            'plural'
        ],
        skipTransformFor: [
            'currency_locale',
            'currency_code',
            'icon',
            'iconIdx',
            'duration_format',
            'is_multi',
            'is_progress',
            'max'
        ]
    },
    transformFn: (data)=>{
        const meta = data.meta || {};
        let colOptions;
        switch(data.uidt){
            case _nocodbsdk.UITypes.SingleSelect:
            case _nocodbsdk.UITypes.MultiSelect:
                {
                    // when choices not sent, do not override
                    if (meta.choices) {
                        var _ref;
                        var _meta_choices;
                        const choices = (_ref = (_meta_choices = meta.choices) == null ? void 0 : _meta_choices.map((opt)=>{
                            const res = {
                                title: opt.title,
                                color: opt.color
                            };
                            if (opt.id) res.id = opt.id;
                            return res;
                        })) != null ? _ref : [];
                        colOptions = {
                            options: choices
                        };
                    }
                }
                break;
            default:
                break;
        }
        if (data.uidt === _nocodbsdk.UITypes.Checkbox) {
            const { icon } = meta, _ = _object_without_properties_loose(meta, [
                "icon"
            ]);
            if (icon) {
                const iconIdx = _nocodbsdk.checkboxIconList.findIndex((ic)=>ic.label === icon);
                if (iconIdx !== -1) {
                    const _checkboxIconList_iconIdx = _nocodbsdk.checkboxIconList[iconIdx], { label: _ } = _checkboxIconList_iconIdx, rest = _object_without_properties_loose(_checkboxIconList_iconIdx, [
                        "label"
                    ]);
                    meta.iconIdx = iconIdx;
                    meta.icon = rest;
                }
            }
        } else if (data.uidt === _nocodbsdk.UITypes.Rating) {
            const { icon } = meta, _ = _object_without_properties_loose(meta, [
                "icon"
            ]);
            if (icon) {
                const iconIdx = _nocodbsdk.ratingIconList.findIndex((ic)=>ic.label === icon);
                if (iconIdx !== -1) {
                    const _ratingIconList_iconIdx = _nocodbsdk.ratingIconList[iconIdx], { label: _ } = _ratingIconList_iconIdx, rest = _object_without_properties_loose(_ratingIconList_iconIdx, [
                        "label"
                    ]);
                    meta.iconIdx = iconIdx;
                    meta.icon = rest;
                }
            }
        } else if (data.uidt === _nocodbsdk.UITypes.Duration) {
            const { duration, duration_format } = meta, _ = _object_without_properties_loose(meta, [
                "duration",
                "duration_format"
            ]);
            const durationFormat = duration != null ? duration : duration_format;
            // extract option meta and include only label and color
            const durationIdx = _nocodbsdk.durationOptions.findIndex((d)=>d.title === durationFormat);
            if (durationIdx > -1) {
                meta.duration = durationIdx;
            }
        } else if (data.uidt === _nocodbsdk.UITypes.MultiSelect) {
            data.cdf = Array.isArray(data.cdf) ? data.cdf.join(',') : data.cdf;
        }
        let additionalPayloadData = {};
        if (columnsWithOptions.includes(data.uidt) && data.meta) {
            additionalPayloadData = columnOptionsV3ToV2Builder().build(data.meta) || {};
        }
        return _extends({}, data, {
            colOptions,
            meta: meta || data.meta
        }, additionalPayloadData);
    }
});
const sortBuilder = builderGenerator({
    allowed: [
        'id',
        'fk_column_id',
        'direction'
    ],
    mappings: {
        fk_column_id: 'field_id'
    }
});
const filterBuilder = builderGenerator({
    allowed: [
        'id',
        'fk_column_id',
        'direction',
        'logical_op',
        'fk_parent_id',
        // 'fk_hook_id',
        // 'fk_view_id',
        'comparison_op',
        'comparison_sub_op',
        'value',
        'is_group',
        'fk_related_col_id',
        'fk_value_col_id'
    ],
    mappings: {
        fk_column_id: 'field_id',
        fk_parent_id: 'parent_id',
        // fk_hook_id: 'hook_id',
        // fk_related_col_id: 'related_field_id',
        fk_value_col_id: 'value_field_id',
        comparison_op: 'operator',
        comparison_sub_op: 'sub_operator'
    },
    excludeNullProps: true,
    booleanProps: [
        'is_group'
    ]
});
const filterRevBuilder = builderGenerator({
    allowed: [
        'id',
        'field_id',
        'parent_id',
        'direction',
        'logical_op',
        'operator',
        'sub_operator',
        'value',
        'is_group'
    ],
    mappings: {
        field_id: 'fk_column_id',
        parent_id: 'fk_parent_id',
        operator: 'comparison_op',
        sub_operator: 'comparison_sub_op'
    }
});
const viewColumnBuilder = builderGenerator({
    allowed: [
        'fk_column_id',
        'width',
        'show',
        'formatting',
        'label',
        'help',
        'description',
        'required',
        'aggregation'
    ],
    mappings: {
        fk_column_id: 'field_id'
    },
    excludeNullProps: true,
    booleanProps: [
        'show',
        'required'
    ],
    transformFn: (formattedData)=>{
        if (formattedData.width === _nocodbsdk.VIEW_GRID_DEFAULT_WIDTH + 'px') {
            formattedData.width = undefined;
        } else if (formattedData.width && typeof formattedData.width === 'string' && formattedData.width !== '') {
            const numberStrWidth = formattedData.width.replace('px', '').trim();
            const numberWidth = Number(numberStrWidth);
            formattedData.width = !isNaN(numberWidth) ? numberWidth : numberStrWidth;
        }
        if (formattedData.aggregation === 'none') {
            delete formattedData.aggregation;
        }
        return formattedData;
    }
});
